document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".product-slider").forEach(slider => {

        const track = slider.querySelector(".product-slider-track");
        const next = slider.querySelector(".product-slider-next");
        const prev = slider.querySelector(".product-slider-prev");

        function slideWidth() {
            const slide = slider.querySelector(".product-slider-slide");
            return slide ? slide.offsetWidth + 24 : 220;
        }

        next.addEventListener("click", () => {
            track.scrollBy({ left: slideWidth(), behavior: "smooth" });
        });

        prev.addEventListener("click", () => {
            track.scrollBy({ left: -slideWidth(), behavior: "smooth" });
        });

    });

});
